import React from 'react';

// Blesk = "nezaplaceno". Drive se pouzival emoji znak ⚡, ktery ma v emoji fontech
// advance ~1.37em a samotny blesk sedi az uprostred glyfu - delal to nechtene mezery
// a kazdy system ho kreslil jinak. Inline SVG ma box presne kolem tvaru a skaluje s pismem.
export default function IconBolt({className = '', title = 'Nezaplaceno'}) {
	return (
		<svg
			className={`icon-bolt${className !== '' ? ` ${className}` : ''}`}
			viewBox="0 0 10 18"
			role="img"
			aria-label={title}
			focusable="false"
		>
			<title>{title}</title>
			<path d="M6.6 0L0 10.2h3.8L3.4 18 10 7.4H6.2z" />
		</svg>
	);
}
